import { RouteErrorBoundary } from 'es/app/components/layout/RouteErrorBoundary';
import RouteMap from 'es/app/views/system/RouteMap';
import { lazy } from 'react';
import { Route } from 'react-router-dom';

const LibraryPollutants = lazy(() => import('es/app/views/system/library/pollutants'));
const PollutantDetails = lazy(() => import('es/app/views/system/library/pollutants/PollutantDetails'));
const LibraryUnits = lazy(() => import('es/app/views/system/library/units'));
const UnitDetails = lazy(() => import('es/app/views/system/library/units/UnitDetails'));
const LibraryNoiseClassifiers = lazy(() => import('es/app/views/system/library/noise-classification/index'));
const UpdateNoiseClassifierModel = lazy(
    () => import('es/app/views/system/library/noise-classification/UpdateNoiseClassifierModel')
);
const CreateNoiseClassifierModel = lazy(
    () => import('es/app/views/system/library/noise-classification/CreateNoiseClassifierModel')
);

export function LibraryRoutes() {
    return (
        <>
            <Route
                path={RouteMap.library.search()}
                element={<LibraryPollutants />}
                ErrorBoundary={RouteErrorBoundary}
            />
            <Route
                path={RouteMap.library.pollutants.search()}
                element={<LibraryPollutants />}
                ErrorBoundary={RouteErrorBoundary}
            >
                <Route path={RouteMap.library.pollutants.view().root} element={<PollutantDetails />} />
            </Route>
            <Route path={RouteMap.library.units.search()} element={<LibraryUnits />} ErrorBoundary={RouteErrorBoundary}>
                <Route path={RouteMap.library.units.view().root} element={<UnitDetails />} />
            </Route>
            <Route
                path={RouteMap.library.noiseClassifications.search()}
                element={<LibraryNoiseClassifiers />}
                ErrorBoundary={RouteErrorBoundary}
            >
                <Route path={RouteMap.library.noiseClassifications.create()} element={<CreateNoiseClassifierModel />} />
                <Route
                    path={RouteMap.library.noiseClassifications.view().root}
                    element={<UpdateNoiseClassifierModel />}
                />
            </Route>
        </>
    );
}
